import AsdcomBase from "@/lib/asdcombase";
import { eventNames } from "cluster";

export enum GlobalEventNamesEnum {
  DashboardUpdate = "global.dashboardupdate",
  ReminderChanged = "global.reminderchanged",
  ApplicantRequestChanged = "global.ApplicantRequestChanged",
  ClaimTaskChanged = "global.ClaimTaskChanged",
}

export class GlobalEventsService extends AsdcomBase {

  constructor() {
    super();

    /// subscribe to global events.
    abp.event.on(GlobalEventNamesEnum.ReminderChanged, this.dashboardUpdate);
    abp.event.on(GlobalEventNamesEnum.ApplicantRequestChanged, this.dashboardUpdate);
    abp.event.on(GlobalEventNamesEnum.ClaimTaskChanged, this.dashboardUpdate);
  }

  public onDashboardUpdate(callbackFunction: any) {
    abp.event.on(GlobalEventNamesEnum.DashboardUpdate, callbackFunction);
  }


  public dashboardUpdate() {
    abp.event.trigger(GlobalEventNamesEnum.DashboardUpdate)
  }

  public reminderChanged() {
    abp.event.trigger(GlobalEventNamesEnum.ReminderChanged);
  }

  public applicantRequestChanged() {
    abp.event.trigger(GlobalEventNamesEnum.ApplicantRequestChanged);
  }

  public claimTaskChanged() {
    abp.event.trigger(GlobalEventNamesEnum.ClaimTaskChanged);
  }



}